import BaseApi from 'core/api/BaseApi';

export default class Bebop extends BaseApi {
  constructor() {
    super();

    this.client.defaults.headers.get['Content-Type'] = 'application/json';

    this.client.interceptors.request.use(
      this.handleRequest,
      this.handleRequestError,
      { synchronous: true }
    );

    this.client.interceptors.response.use(
      this.getData,
      this.handleResponseError,
      { synchronous: true }
    );
  }

  addRequestParams = requestHeaders => {
    const xRequestId = requestHeaders && requestHeaders['x-request-id'];
    if (xRequestId) this.client.defaults.headers.common['X-Request-Id'] = xRequestId;
  };

  handleRequest = request => {
    if (request.method === 'get' && request.params) {
      request.params = this.transformRequestParams(request.params);
    }
    return request;
  };

  getTopics = params => {
    return this.client({
      method: 'get',
      url: '/topics',
      params,
    });
  };

  getExternal = (url, params) => {
    return this.client({
      method: 'get',
      url,
      params,
    });
  };

  getTopicsOrderedBySharesCount = params => {
    return this.client({
      method: 'get',
      url: '/topics/shares',
      params,
    });
  };

  getTopic = params => {
    return this.client({
      method: 'get',
      url: `/topics/${params.topic_link}`,
      params,
      maxRedirects: 0,
    });
  };

  getAlphabet = params => {
    return this.client({
      method: 'get',
      url: '/topics/alphabetical_index',
      params,
    });
  };

  getSearch = params => {
    return this.client({
      method: 'get',
      url: '/search',
      params,
    });
  };

  getTags = params => {
    return this.client({
      method: 'get',
      url: '/tags',
      params,
    });
  };

  getTag = params => {
    return this.client({
      method: 'get',
      url: `/tags/${params.tag_slug}`,
      params,
    });
  };

  getLists = params => {
    return this.client({
      method: 'get',
      url: '/lists',
      params,
    });
  };

  getList = params => {
    return this.client({
      method: 'get',
      url: `/lists/${params.list_slug}`,
      params,
    });
  };

  getRubric = params => {
    return this.client({
      method: 'get',
      url: `/rubrics/${params.rubric_slug}`,
      params,
    });
  };

  getAuthors = params => {
    return this.client({
      method: 'get',
      url: '/authors',
      params,
    });
  };

  getAuthor = params => {
    return this.client({
      method: 'get',
      url: `/authors/${params.author_slug}`,
      params,
    });
  };

  getMenus = params => {
    return this.client({
      method: 'get',
      url: '/menus',
      params,
    });
  };

  getMenu = params => {
    return this.client({
      method: 'get',
      url: `/menus/${params.menu_slug}`,
      params,
    });
  };

  getPuids = params => {
    return this.client({
      method: 'get',
      url: `/puids/${params.puid_link}`,
      params,
    });
  };

  getAboutPage = params => {
    return this.client({
      method: 'get',
      url: '/about_page',
      params,
    });
  };

  getReactions = params => {
    return this.client({
      method: 'get',
      url: '/reactions',
      params,
    });
  };

  submitReaction = params => {
    return this.client({
      method: 'post',
      url: '/reactions',
      params,
    });
  };

  deleteReaction = params => {
    return this.client({
      method: 'delete',
      url: `/reactions/${params.uuid}`,
      params,
    });
  };
}

export const bebop = new Bebop();
